export default "__VITE_ASSET__81c9ba7d__"